export default {
    profile: "Perfil",
    company: "Companhia",
    users: "Usuários",
    "my-account": "Minha Conta",
    "profile-tab": {
        "change-password": "Trocar senha",
        "save-changes": "Salvar mudanças",
        "e-mail": "E-mail",
        "document-type": "Tipo de documento",
        "document-number": "Número do documento",
        "preferred-language": "Idioma preferido",
        "gtn-profile": "Perfil GTN",
        "recover-tfa": "Recuperar 2FA",
        "enable-tfa": "Habilitar 2FA",
        "disable-tfa": "Desabilitar 2FA",
        "2fa": "Autenticação de dois fatores",
        profile: "Perfil",
        name: "Nome",
        cancel: "Cancelar",
        country: "País",
        security: "Segurança",
        password: "Senha",
        "enterprise-account": "Conta empresarial",
        "personal-account": "Conta pessoal",
        "preferred-name": "Nome preferido",
        "uses-preferred-name": "Use nome preferido",
        "job-description": "Descrição do trabalho",
    },
    "company-tab": {
        "company-name": "Nome da companhia",
        industry: "Indústria",
        "trade-name": "Nome fantasia",
        "company-size": "Tamanho da companhia",
        website: "Website",
        "document-type": "Tipo de documento",
        "document-number": "Número do documento",
        "edit-company": "Editar companhia",
        contact: "Contato",
        "edit-contacts": "Editar contatos",
        name: "Nome",
        email: "Email",
        phone: "Telefone",
        address: "Endereço",
        "address-type": "Tipo de endereço",
        "postal-code": "CEP",
        country: "País",
        state: "Estado",
        city: "Cidade",
        neighborhood: "Bairro",
        street: "Rua",
        number: "Número",
        complement: "Complemento (Opcional)",
        "edit-address": "Editar endereço",
        "modal-edit-company": {
            "edit-company": "Editar companhia",
            "company-name": "Nome da companhia",
            "company-name-required": "Nome da companhia é obrigatório",
            "trade-name": "Nome fantasia",
            "trade-name-required": "Nome fantasia é obrigatório",
            "company-size": "Tamanho da companhia",
            "company-size-required": "Tamanho da companhia é obrigatório",
            segmentation: "Segmentação",
            industry: "Indústria",
            "industry-required": "Indústria é obrigatória",
            website: "Website",
            "website-required": "Website é obrigatório",
            "document-type": "Tipo de documento",
            "document-type-required": "Tipo de documento é obrigatório",
            document: "Documento",
            "document-required": "Documento é obrigatório",
            cancel: "Cancel",
            save: "Save Changes",
        },
        "modal-edit-address": {
            "edit-companys-address": "Editar endereços da companhia",
            address: "Endereço",
            "remove-address": "Remover endereço",
            "add-address": "Adicionar outro endereço",
            cancel: "Cancelar",
            save: "Salvar alterações",
            "address-type": "Tipo de endereço",
            "address-type-required": "Tipo de endereço é obrigatório",
            "zip-code": "CEP",
            "zip-code-required": "CEP é obrigatório",
            country: "País",
            "country-required": "País é obrigatório",
            state: "Estado",
            "state-required": "Estado é obrigatório",
            city: "Cidade",
            "city-required": "Cidade é obrigatória",
            neighborhood: "Bairro",
            "neighborhood-required": "Bairro é obrigatório",
            street: "Rua",
            "street-required": "Rua é obrigatória",
            number: "Número",
            "number-required": "Número é obrigatório",
            complement: "Complemento",
        },
        "modal-edit-contact": {
            "edit-companys-contact": "Editar contatos da companhia",
            contact: "Contato",
            "remove-contact": "Remover contato",
            "add-contact": "Adicionar outro contato",
            cancel: "Cancelar",
            save: "Salvar alterações",
            "contact-type": "Tipo de contato",
            "contact-type-required": "Tipo de contato é obrigatório",
            "first-name": "Nome",
            "first-name-required": "Nome é obrigatório",
            "last-name": "Sobrenome",
            "last-name-required": "Sobrenome é obrigatório",
            email: "Email",
            "email-required": "Email é obrigatório",
            "country-code": "Código do país",
            "country-code-required": "Código do país é obrigatório",
            "phone-number": "Número de telefone",
            "phone-number-required": "Número de telefone é obrigatório",
        },
    },
    "users-tab": {
        modal: {
            "remove-user": {
                title: "Remover usuário",
                subtitleFirstPart: "Ao confirmar a remoção, o usuário",
                subtitleLastPart: "deixará de fazer parte desta conta e perderá o acesso a todas as suas funcionalidades.",
            },
            "change-owner": {
                title: "Alterar owner?",
                subtitleFirstPart: "Só pode haver um proprietário por empresa. Ao confirmar, este usuário",
                subtitleLastPart: "será o único owner desta empresa.",
            },
            "change-employee": {
                title: "Alterar para employee",
                subtitleFirstPart: "Ao confirmar, este usuário",
                subtitleLastPart: "será um employee desta empresa.",
            },
            "change-admin": {
                title: "Alterar para admin",
                subtitleFirstPart: "Ao confirmar, este usuário",
                subtitleLastPart: "será um admin desta empresa.",
            },
            "add-user": {
                title: "Adicionar usuário",
                subtitleFirstPart: "Ao confirmar, o usuário",
                subtitleLastPart: "será adicionado como employee desta empresa.",
            },
            buttons: {
                cancel: "cancelar",
                confirm: "confirmar",
            },
        },
        "add-user-button": "Adicionar usuário",
        "table-columns": {
            name: "nome",
            "last-access": "Último acesso",
            role: "função",
        },
        "new-access-request": "novo(s) pedido(s) de acesso",
        "users-email": "Email do usuário",
        "users-not-found": "Usuários não encontrados.",
    },
    "rock-content-team": "Equipe Rock Content",
    "no-rock-content-team": "Sem equipe Rock Content",
};
